import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {BranchModel} from "../../models/branch.model";

export class branchesMultiSelectCtrl implements IController {

  selectedIds: string[];
  tags?: string[];
  options?: any;
  optionIds?: string[];
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  hideGroupsFilter: boolean;
  onChange: Function;

  public selectedBranches: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private branchesRequests, private $element) {
  }

  $onInit() {
    this._setSelectedBranches();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedBranches();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const tagsRef = this.tags || [];
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const selectSettingsRef = {
      hideGroupsFilter: this.hideGroupsFilter
    };

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'select-settings="ctrl.selectSettingsRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'branches';
        this.selectedIdsRef = selectedIdsRef;
        this.queryMapRef = {
          tags: tagsRef
        };
        this.tagsRef = tagsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.selectSettingsRef = selectSettingsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({branches: [], selectedIds: []});
          panel.destroy();
        } else {
          if (!!this.options) {
            const branches = _.filter(this.options, (o) => {
              return _.includes(selectedIds, o.id);
            });
            this.onChange({branches: branches, selectedIds: selectedIds});
            panel.destroy();
          } else {
            this.branchesRequests.getBranchesByIds(selectedIds)
              .then((branches: BranchModel[]) => {
                this.onChange({branches: branches, selectedIds: selectedIds});
                panel.destroy();
              });
          }
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedIds: []});
  }

  private _setSelectedBranches() {
    if (!!this.selectedIds?.length) {
      if (!!this.options) {
        this.selectedBranches = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this.branchesRequests.getBranchesByIds(this.selectedIds)
          .then((branches: BranchModel[]) => {
            this.selectedBranches = _.orderBy(branches, ['name'], ['asc']);
            this._setSelectedText();
          })
      }
    } else {
      this.selectedBranches = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedBranches, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedBranches.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedBranches[0].name;
      if(this.selectedBranches.length - 1) {
        string += ` +${this.selectedBranches.length - 1}`
      }
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.branches')
  .component('branchesMultiSelect', {
    bindings: {
      selectedIds: '<?',
      tags: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      hideGroupsFilter: '<?',
      onChange: '&'
    },
    template: require('./branches-multi-select.html').default,
    controller: branchesMultiSelectCtrl
  });
